import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiUrl = environment.API_URL;

  constructor(
    private http: HttpClient
  ) { }

  login(data: IHttpData) {
    return this.http.post<IApiResponse>(`${this.apiUrl}/auth/login`, data).toPromise();
  }

  externalAuth(data: IHttpData) {
    return this.http.post<IApiResponse>(`${this.apiUrl}/auth/externalAuth`, data).toPromise();
  }

  paymentIntent(data: IHttpData) {
    return this.http.post<IApiResponse>(`${this.apiUrl}/payment/intent`, data).toPromise();
  }

  purchaseSubscription(data: IHttpData) {
    return this.http.post<IApiResponse>(`${this.apiUrl}/payment/purchaseSubscription`, data).toPromise();
  }

  post(url: string, data: IHttpData, options?: { headers?: { [header: string]: string } }) {
    return this.http.post<IApiResponse>(`${this.apiUrl}${url}`, this.normalizePayload(data), options).toPromise();
  }

  put(url: string, data: IHttpData) {
    return this.http.put<IApiResponse>(`${this.apiUrl}${url}`, this.normalizePayload(data)).toPromise();
  }

  patch(url: string, data: IHttpData) {
    return this.http.patch<IApiResponse>(`${this.apiUrl}${url}`, this.normalizePayload(data)).toPromise();
  }

  postText(url: string, data: IHttpData) {
    return this.http.post(`${this.apiUrl}${url}`, data, { responseType: 'text' }).toPromise();
  }

  sendEmail(url: string, data: IHttpData) {
    return this.http.post<IApiResponse>(`${this.apiUrl}${url}`, this.normalizePayload(data)).toPromise();
  }

  delete(url: string, data: IHttpData) {
    return this.http.delete<IApiResponse>(`${this.apiUrl}${url}`, data).toPromise();
  }

  get(url: string, options: HttpParams) {
    return this.http.get<IApiResponse>(`${this.apiUrl}${url}`, { params: options }).toPromise();
  }

  private normalizePayload(data: IHttpData) {
    if (data && typeof (data as any).toJson === 'function') {
      return (data as any).toJson();
    }

    return data;
  }
}

interface IHttpData {
  [key: string]: any;
}

interface IApiResponse {
  [key: string]: any;
  data: any;
  error: any;
  message: string;
  statusCode: 200;
}
